export enum FieldEnum {
  ID = "id",
  MISSION_ID = "mission_id",
  USER_ID = "user_id",
}
